import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 .277a1.04 1.04 0 0 0-.94.596L4.472 4.078l-.012.023-.005.002-.018.002-3.496.518a1.04 1.04 0 0 0-.617 1.788L2.883 8.88l.006.005a.03.03 0 0 1 .009.027v.004l-.61 3.568v.001a1.05 1.05 0 0 0 1.526 1.107l3.15-1.665a.1.1 0 0 1 .072 0l3.15 1.664a1.049 1.049 0 0 0 1.527-1.106l-.61-3.57v-.003q-.002-.007 0-.014l.008-.013.006-.005 2.559-2.47a1.04 1.04 0 0 0-.617-1.787l-3.496-.518-.023-.004-.003-.004-.009-.019L7.94.873A1.04 1.04 0 0 0 7 .277",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceFavoriteStar = { render };
export {
  interfaceFavoriteStar as default,
  render
};
//# sourceMappingURL=interface-favorite-star.svg.js.map
